import Controller, { OnClose } from '@philips-emr/tws-core/lib/client';

import BaseController from '../BaseController';

@Controller({ fragment: 'privacy-warning' })
export default class PrivacyWarningController extends BaseController {

  @OnClose('panel-privacy-warning-main')
  onCloseModalWarning(): void {
    this.historyService.back();
  }
}
